export default __webpack_public_path__ + "static/media/Theme15.78710174.png";